var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76623 9.765C6.23412 8.34945 7.1371 7.11781 8.34635 6.2458C9.55561 5.37379 11.0094 4.90594 12.5002 4.909C14.1902 4.909 15.7182 5.509 16.9182 6.491L20.4102 3C18.2822 1.145 15.5552 0 12.5002 0C7.77024 0 3.69823 2.698 1.74023 6.65L5.76623 9.765Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5393 18.0131C15.4493 18.7161 14.0653 19.0911 12.4993 19.0911C11.0144 19.0941 9.56613 18.63 8.35956 17.7644C7.153 16.8988 6.24927 15.6757 5.77633 14.2681L1.73633 17.3351C2.72757 19.3414 4.2616 21.0295 6.16415 22.2076C8.06671 23.3858 10.2615 24.0068 12.4993 24.0001C15.4323 24.0001 18.2343 22.9571 20.3333 21.0001L16.5403 18.0131H16.5393Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.334 21.0004C22.529 18.9524 23.954 15.9044 23.954 12.0004C23.954 11.2904 23.845 10.5274 23.682 9.81836H12.5V14.4554H18.936C18.619 16.0144 17.766 17.2214 16.541 18.0134L20.334 21.0004Z",
    fill: "#4A90E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77712 14.2679C5.53247 13.5368 5.40819 12.7708 5.40912 11.9999C5.40912 11.2179 5.53412 10.4669 5.76612 9.7649L1.74012 6.6499C0.916494 8.31259 0.49192 10.1444 0.500116 11.9999C0.500116 13.9199 0.945116 15.7299 1.73712 17.3349L5.77712 14.2679Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.cebabc28464d4778d8db7675347b3c08.svg";
export { ForwardRef as ReactComponent };